export default __webpack_public_path__ + "static/media/unstaking-step-three-bondly-eth.b2198f71.svg";